var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cms-shell',{attrs:{"data":_vm.data,"title":"Adresse"},on:{"up":function($event){_vm.$emit('up', -1, _vm.data)},"down":function($event){_vm.$emit('down', 1, _vm.data)},"remove":function($event){_vm.$emit('remove', _vm.data)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3122acc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cms/CmsAddress.vue
// module id = null
// module chunks = 